import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { checkOrgPermissions } from '@ui/guards/route-checks';
export const Route = createFileRoute('/org/$organization/settings/server-tokens')({
    loader: async (param)=>{
        let { params, context: { queryClient } } = param;
        var _ref;
        const can = await checkOrgPermissions(queryClient, params.organization);
        return {
            canUpdateOrganizationSettings: (_ref = can === null || can === void 0 ? void 0 : can.updateOrganizationSettings) !== null && _ref !== void 0 ? _ref : false
        };
    },
    component: RouteComponent
});
function RouteComponent() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
